<section class="mb-7">
  <div class="w-fit">
    <h2 class="text-47 mb-5 flex flex-wrap justify-center font-bold gap-x-2">
      <span>{{
        "frequently-asked-questions_subtitle_privacy_and_security" | translate
      }}</span>
    </h2>
  </div>
  <div class="bg-[#F4F4F4] dark:bg-[#0F0F0F] w-full rounded mt-4 lg:mt-7 mb-5">
    <mat-accordion multi>
      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(0)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div
              class="text-ayr-black dark:text-white flex items-center gap-2 teste"
            >
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[0].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_how_does_AYR_protect" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{
              "frequently-asked-questions_how_does_AYR_protect_1" | translate
            }}
          </p>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel hideToggle (expandedChange)="onExpandChange(1)">
        <mat-expansion-panel-header
          class="!h-auto dark:hover:!bg-[#202020] dark:focus-active:!bg-[#202020] hover:!bg-[#f0efef] focus-active:!bg-[#f0efef] text-ayr-black dark:text-white"
        >
          <mat-panel-title>
            <div class="text-ayr-black dark:text-white flex items-center gap-2">
              @if (darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right-dark.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              @if (!darkMode) {
                <img
                  class="duration-200"
                  [ngClass]="{ 'rotate-90': principalAccordion[1].expanded }"
                  src="https://storage.googleapis.com/weayr-assets-non-prod/images/icons/accordion-arrow-right.svg"
                  width="16"
                  height="16"
                  alt="arrow right"
                />
              }
              <span class="dark:text-white">{{
                "frequently-asked-questions_can_I_delete" | translate
              }}</span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mat-expansion-content text-ayr-black dark:text-white">
          <p class="!text-ayr-black dark:!text-white">
            {{ "frequently-asked-questions_can_I_delete_1" | translate }}
          </p>
          <p class="!text-ayr-black dark:!text-white">
            {{ "frequently-asked-questions_can_I_delete_2" | translate }}
          </p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</section>
